import styled from 'styled-components';

interface IProps {}

export const ExcludeRuleConditionStyled = styled.div<IProps>`
  .wrap-button {
    min-width: 110px;
  }
`;
